// extracted by mini-css-extract-plugin
module.exports = {"shadow":"DatePickerStyles_shadow__1df4b","dates-wrapper":"DatePickerStyles_dates-wrapper__2gaBG"};